// Module
var code = "<h2 id=\"email\">Email</h2> <p>Send us a secure email through Account Access.</p> ";
// Exports
export default code;